var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18595 9.23478C1.8487 6.89136 2.58741 3.92689 4.83591 2.61345C7.0844 1.30002 9.99122 2.13499 11.3285 4.47841L17.1985 14.7652C18.5358 17.1086 17.797 20.0731 15.5485 21.3865C13.3001 22.6999 10.3932 21.865 9.05598 19.5215L3.18595 9.23478Z",
    fill: "url(#paint0_linear_2290_2172)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2349 6.6917C27.2349 9.32347 25.1345 11.4569 22.5435 11.4569C19.9525 11.4569 17.8521 9.32347 17.8521 6.6917C17.8521 4.05992 19.9525 1.92645 22.5435 1.92645C25.1345 1.92645 27.2349 4.05992 27.2349 6.6917Z",
    fill: "url(#paint1_linear_2290_2172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2290_2172",
    x1: 4.83591,
    y1: 2.61345,
    x2: 15.441,
    y2: 21.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2290_2172",
    x1: 22.5435,
    y1: 1.92645,
    x2: 22.5205,
    y2: 11.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9AA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d71cb02bb8152159a2b0a6ea6342ef2.svg";
export { ForwardRef as ReactComponent };